import React from 'react'
import Icon from 'lib/components/icon'
import Tooltip from 'lib/components/tooltip'
import { formatTable } from '../format'

class SidebarStats extends React.PureComponent {
  static defaultProps = {
    aggregate: {},
    description: '',
    getLabel: n => n,
    sidebarGroups: [],
    tooltips: {}
  }

  renderAttributeTitle(attribute) {
    const { tooltips, getLabel } = this.props
    const label = getLabel(attribute)

    return tooltips[attribute] ? (
      <Tooltip overlay={tooltips[attribute]}>
        {label} <Icon type="info" width="16px" height="16px" />
      </Tooltip>
    ) : (
      label
    )
  }

  renderStat(attribute) {
    const { aggregate } = this.props

    return (
      <tr key={attribute} className="sidebar-stats__item">
        <td className="sidebar-stats__expand">
          <div className="sidebar-stats__label">
            {this.renderAttributeTitle(attribute)}
          </div>
        </td>
        <td className="sidebar-stats__value">
          {formatTable(aggregate[attribute], attribute)}
        </td>
      </tr>
    )
  }

  renderStatGroup(group) {
    return (
      <table key={`stats-${group.label}`} className="sidebar-stats">
        <thead className="sidebar-stats__header">
          <tr>
            <th className="sidebar-stats__heading type-title" colSpan="2">
              {group.label} <span className="screenreader-only">Value</span>
            </th>
          </tr>
        </thead>
        <tbody>{group.attributes.map(this.renderStat, this)}</tbody>
      </table>
    )
  }

  render() {
    const { aggregate, sidebarGroups } = this.props

    return (
      <div>{aggregate && sidebarGroups.map(this.renderStatGroup, this)}</div>
    )
  }
}

export default SidebarStats



// WEBPACK FOOTER //
// ./src/components/sidebar-stats.js